import DescriptionItem from "./DescriptionItem";

export default DescriptionItem;
